import { formatService, FORMAT_TYPES } from '../common/format.service'

class BarChartService {
  transformData (data, { xField, yField, groupField, labels }) {
    if (labels && typeof labels === 'object' && !Array.isArray(labels)) {
      // Convert to array
      labels = Object.entries(labels).map(([value, label]) => ({ label, value }))
    } else if (!Array.isArray(labels)) {
      labels = []
    }
    const mappedLabels = []
    const labelsHash = labels.reduce((labelsHash, { value, label }) => {
      labelsHash[value] = label
      return labelsHash
    }, {})

    // sort data if the x values are numeric
    if (data.length > 0 && typeof data[0][xField] === 'number') {
      data.sort((a, b) => a[xField] - b[xField])
    }

    const transformed = data.reduce((transformed, r) => {
      const x = r[xField].toString()
      let resultRow = transformed.find((r) => r[xField] === x)
      if (!resultRow) {
        resultRow = { [xField]: x }
        transformed.push(resultRow)
      }
      let group = r[groupField]

      // Non-grouped data
      if (group === undefined) {
        group = yField
      }

      if (!mappedLabels.find(({ key }) => key === group)) {
        const label = (labelsHash[group] !== undefined)
          ? labelsHash[group]
          : group
        mappedLabels.push({ key: group, label })
      }

      resultRow[group] = r[yField]

      return transformed
    }, [])

    if (labels) {
      // Order legend based on the order of thet labels passed in
      const order = labels.map(({ label }) => label)
      mappedLabels.sort(({ label: label1 }, { label: label2 }) => {
        let label1Index = order.indexOf(label1)
        let label2Index = order.indexOf(label2)
        label1Index = label1Index === -1 ? mappedLabels.length : label1Index
        label2Index = label2Index === -1 ? mappedLabels.length : label2Index
        return label1Index - label2Index
      })
    }

    return {
      data: transformed,
      keys: mappedLabels.map(({ key }) => key),
      labels: mappedLabels.map(({ label }) => label)
    }
  }

  /**
   * Shorten the format for axis labels
   */
  formatAxisValue (value, format) {
    format = (format === FORMAT_TYPES.NUMBER) ? FORMAT_TYPES.NUMBER_SHORT : format
    format = (format === FORMAT_TYPES.PERCENT) ? FORMAT_TYPES.PERCENT_SHORT : format
    return formatService.formatValue(value, format)
  }
}

export const barChartService = new BarChartService()
